export const REQUEST_DOWNLOAD_FILE = 'REQUEST_DOWNLOAD_FILE';

export const requestDownloadFile = (url: string, filename: string, extension: string) => ({
  type: REQUEST_DOWNLOAD_FILE,
  url,
  filename,
  extension,
});
